import React from 'react';
import Slider from 'react-slick';
import TargetCard from './TargetCard';
import { Col, Container, Row } from 'reactstrap';
import ExpertiseNavigation from './ExpertiseNavigation';
import { targetAudiences } from './servicesData';
import useIsMobile from './useIsMobile';

const WhoIsItFor: React.FC = () => {
  const isMobile = useIsMobile(992);
  const itemsPerSlide = isMobile ? 1 : 2;

  const sliderRef = React.useRef<Slider | null>(null);

  const settings = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: itemsPerSlide,
    slidesToScroll: 1,
    adaptiveHeight: true,
    draggable: isMobile,
    swipe: isMobile,
  };

  const nextSlide = () => {
    sliderRef.current?.slickNext();
  };

  const prevSlide = () => {
    sliderRef.current?.slickPrev();
  };

  const totalSlides = Math.ceil(targetAudiences.length / itemsPerSlide);
  const [currentSlide, setCurrentSlide] = React.useState(0);

  const handleBeforeChange = (_: number, next: number) => {
    setCurrentSlide(next);
  };

  return (
    <section className=" section-gap-lg who-section">
      <Container className="who-section-container">
        <Row className="who-section-header text-center">
          <Col data-aos="fade-up">
            <h2 className="who-section-title">
              Who <span>is it for?</span>
            </h2>
            <p className="who-section-subtitle">
              Legalligence streamlines legal work for firms and individuals through expert insight,
              smart tools, and a focus on clarity and results.
            </p>
          </Col>
        </Row>
        <div className="who-section-slider" data-aos="fade-up" data-aos-delay="200">
          <Slider ref={sliderRef} {...settings} beforeChange={handleBeforeChange}>
            {targetAudiences.map((audience) => (
              <TargetCard
                key={audience.id}
                icon={audience.icon}
                title={audience.title}
                description={audience.description}
              />
            ))}
          </Slider>
          <ExpertiseNavigation
            onPrev={prevSlide}
            onNext={nextSlide}
            isFirst={currentSlide === 0}
            isLast={currentSlide >= totalSlides}
          />
        </div>
      </Container>
    </section>
  );
};

export default WhoIsItFor;
